import { useState } from 'react'
import { useDropzone } from 'react-dropzone';
import AzureService from '../services/AzureService';


const UploadFile = ({ folderName, onFileUpload }) => {
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);

    const azureService = new AzureService(
        process.env.REACT_APP_AZURE_CONTAINER_URL,
        process.env.REACT_APP_AZURE_SAS_TOKEN
    );


    const onDrop = async (acceptedFiles) => {
        const uploadedFiles = await Promise.all(
            acceptedFiles.map(async (file) => {
                const uploadedUrl = await uploadFile(file);
                return { file, url: uploadedUrl };
            })
        );
        const validFiles = uploadedFiles.filter((item) => item !== null);
        setFiles((prevFiles) => [...prevFiles, ...validFiles]);

        if (onFileUpload) {
            onFileUpload(validFiles.map((file) => file.url));
        }
    };

    const uploadFile = async (file) => {
        setUploading(true);
        try {
            return await azureService.uploadFile(folderName, file);
        } catch (error) {
            console.error("Error uploading file:", error);
            return null;
        } finally {
            setUploading(false);
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: true,
        accept: {
            'image/jpeg': [],
            'image/png': [],
            'image/jpg': [],
        },
    });

    const handleRemoveFile = async (index) => {
        const fileToRemove = files[index];
        try {
            await azureService.deleteFile(folderName, fileToRemove.file.name);
            setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        } catch (error) {
            console.error("Error removing file:", error);
        }
    };
    return (
        <>
            <div {...getRootProps()} className="dropzone dropzone-multiple dz-clickable">
                <ul className="dz-preview dz-preview-multiple list-group list-group-lg list-group-flush"></ul>
                <div className="dz-default dz-message">
                    <input {...getInputProps()} />
                    <button className="dz-button" type="button">
                        Drop files here to upload
                    </button>
                </div>
            </div>
            <div className="file-preview">
                {files.length > 0 ? (
                    files.map((fileData, index) => (
                        <div key={index} className="file-item" style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                            <img
                                src={fileData?.url}
                                alt={fileData?.file?.name}
                                style={{ width: "90px", height: "90px", objectFit: "cover", marginRight: "10px" }}
                            />
                            <button
                                type="button"
                                style={{
                                    background: "none",
                                    border: "none",
                                    color: "red",
                                    cursor: "pointer",
                                }}
                                onClick={() => handleRemoveFile(index)}
                            >
                                Remove
                            </button>
                        </div>
                    ))
                ) : (
                    <p></p>
                )}
                {uploading && <p>Uploading...</p>}
            </div>
        </>
    );
}

export default UploadFile